"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
const _appearance_1 = require("./_appearance");
/**
 * Shop by category (SP5b) — two modes:
 *  - `categories`: pick which store categories to show (or all); each tile pulls
 *    the category's own image + links to its page.
 *  - `custom`: hand-built tiles (upload image + label + link) via `tile` blocks —
 *    e.g. a promo tile with its own image and "Go to category" button.
 */
(0, manifest_1.registerSection)({
    type: 'category-grid', label: 'Shop by category', icon: 'layout-grid', category: 'products',
    settingsSchema: zod_1.z.object({
        title: zod_1.z.string().max(120).default('Shop by category'),
        eyebrow: zod_1.z.string().max(60).default('Browse'),
        source: zod_1.z.enum(['categories', 'custom']).default('categories'),
        columns: zod_1.z.number().int().min(2).max(6).default(4),
        limit: zod_1.z.number().int().min(1).max(24).default(12),
        categoryIds: zod_1.z.array(zod_1.z.string()).default([]), // empty => all categories
        ..._appearance_1.appearanceShape,
    }),
    blockTypes: {
        tile: { label: 'Tile', icon: 'image', max: 24,
            settingsSchema: zod_1.z.object({
                imageUrl: zod_1.z.string().default(''),
                label: zod_1.z.string().max(80).default(''),
                href: zod_1.z.string().default('/category/all'),
            }) },
    },
    maxBlocks: 24,
    defaults: () => ({ title: 'Shop by category', eyebrow: 'Browse', source: 'categories', columns: 4, limit: 12, categoryIds: [], ...(0, _appearance_1.appearanceDefaults)() }),
    fields: [
        { name: 'title', label: 'Title', control: 'text', group: 'Content' },
        { name: 'eyebrow', label: 'Eyebrow', control: 'text', group: 'Content' },
        { name: 'source', label: 'Show', control: 'select', group: 'Content', options: [
                { label: 'Store categories', value: 'categories' }, { label: 'Custom tiles', value: 'custom' },
            ] },
        { name: 'categoryIds', label: 'Categories', control: 'category-ids', group: 'Content', showWhen: { field: 'source', equals: 'categories' } },
        { name: 'columns', label: 'Columns', control: 'number', min: 2, max: 6, group: 'Content' },
        { name: 'limit', label: 'Max tiles', control: 'number', min: 1, max: 24, group: 'Content', showWhen: { field: 'source', equals: 'categories' } },
        ..._appearance_1.appearanceFields,
    ],
    blockFields: {
        tile: [
            { name: 'imageUrl', label: 'Image', control: 'image' },
            { name: 'label', label: 'Label', control: 'text' },
            { name: 'href', label: 'Link (button) URL', control: 'url' },
        ],
    },
});
//# sourceMappingURL=category-grid.js.map